import BannerFlush from 'components/Content/BannerLayout/BannerFlush';
import BannerIcon from 'components/Content/BannerLayout/BannerIcon';

export default {
    BannerFlush,
    BannerIcon
};
